module.exports = "/images/no-collection.png?4c17c65cf8928a5edf0371ea681d1079";